import { IParameterNames } from 'src/views/Links/types';

export function calculateTableWidth(
  parameterNames: IParameterNames,
  STATIC_COLUMN_WIDTHS: number
) {
  return parameterNames.reduce(
    (acc, { length }) => acc + length,
    STATIC_COLUMN_WIDTHS
  );
}



// WEBPACK FOOTER //
// ./src/services/links/calculateTableWidth.ts